module.exports = __webpack_public_path__ + "static/images/collapse.1bg2PVU.svg";